// react
import React, { Fragment, useEffect, useState } from "react";
// store
import { categoryService } from "../../../../store/services/ServiceCategory";
import { LOADING_TIME } from "../../../../store/config";
// components
import HeaderTitle from "../../../../components/others/HeaderTitle";
import CategoryForm from "./CategoryForm";
import Loading from "../../../../components/others/Loading";
// others
import { GAPageView, initGA } from "../../../../index";

// component
function CategoryEdit(props) {
    // state
    const [category, setCategory] = useState({});
    const [categoryId] = useState(props.match.params.id);
    const [isLoading, setIsLoading] = useState(false);

    // Google analytics
    useEffect(() => {
        initGA();
        GAPageView();
    }, []);

    // get data about category according to category id
    useEffect(() => {
        const fetchData = async () => {
            setIsLoading(true);
            const result = await categoryService.getCategoryById(categoryId);
            setCategory(result[0]);

            setTimeout(function () {
                setIsLoading(false);
            }, LOADING_TIME);
        };
        fetchData();
    }, [categoryId]);

    // template
    return (
        <Fragment>
            {isLoading ? (
                <Loading />
            ) : (
                <>
                    <HeaderTitle title="Upraviť kategóriu" />
                    <section>
                        <CategoryForm
                            data={category ? category : {}}
                            isEdit={true}
                        />
                    </section>
                </>
            )}
        </Fragment>
    );
}

export default CategoryEdit;
